export default class Predecessor {
  position = 0;
  name = '';
}
